// src/components/team/RecipientListItem.jsx
//
// Per-recipient row on the Re-engagement Review screen. Shows the
// parent's name, a MASKED phone (security review F2 — full phone
// stays server-side), and the language they'll receive the message
// in. Small + reusable; could be re-used by other future bulk-send
// surfaces (e.g. payment reminder bulk-send) without modification.
//
// Approved spec: features/disengaged-parent/02-wireframe.md §3
// (Screen 2 layout), AD6 (phone masking), WD5 (language indicator).

import React from 'react';
import { useTranslation } from 'react-i18next';
import { DevicePhoneMobileIcon } from '@heroicons/react/24/outline';

export default function RecipientListItem({ displayName, phoneMasked, language }) {
  const { t } = useTranslation();
  const langLabel =
    language === 'es'
      ? t('smartActions.disengagedParent.languageSpanish')
      : t('smartActions.disengagedParent.languageEnglish');

  return (
    <div className="flex items-center gap-3 px-4 py-3 border-b border-zinc-100 last:border-b-0">
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-[#0d1f14] truncate">
          {displayName}
        </p>
        <p className="mt-0.5 text-xs text-zinc-500 flex items-center gap-1.5">
          <DevicePhoneMobileIcon className="h-3.5 w-3.5 text-zinc-400" />
          <span className="font-mono">{phoneMasked}</span>
          <span className="text-zinc-300">·</span>
          <span>{langLabel}</span>
        </p>
      </div>
    </div>
  );
}
